import { Box, IconButton, Link as OuterLink, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

import { Priority } from '../../components/Priority';
import settings from '../../services/settings';
import { IRelatedStoryMapper, IUserSegment } from '../../services/types';
import { RouteNames } from '../config';
import useStyles from './styles';

interface IRelatedStoriesData {
  [key: string]: {
    segment: IUserSegment;
    relatedStories: IRelatedStoryMapper[];
  };
}

interface IProps {
  data?: IRelatedStoriesData;
  onDeleteMapper: (mapperId: number) => void;
  onChangePriority: (mapperId: number, priority: number) => void;
}

const RelatedStorySegment = (props: IProps): JSX.Element => {
  const classes = useStyles();

  if (props.data === undefined) {
    return <Paper className={classes.noData}>no data</Paper>;
  }

  const segmentIds = Object.keys(props.data);

  return (
    <Box>
      {segmentIds.map((segmentId: string) => {
        const segment = props.data![segmentId].segment;
        const relatedMappers = props.data![segmentId].relatedStories.sort((a, b) => {
          return a.priority - b.priority || b.id! - a.id!;
        });
        return (
          <Box key={`segment-box-${segmentId}`} className={classes.segmentContainer}>
            <Paper>
              <Box className={classes.segmentTitle}>
                <span className={classes.segmentLabel}>Segment</span>
                <Link to={`${RouteNames.UserSegment}/v/${segment.id}`} target="_blank" className={classes.segmentName}>
                  {segment.name}
                </Link>
              </Box>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell width="100" align="center">
                      Priority
                    </TableCell>
                    <TableCell width="90" align="center">
                      ID
                    </TableCell>
                    <TableCell>Title</TableCell>
                    <TableCell width="160" align="center">
                      Writer
                    </TableCell>
                    <TableCell width="80" align="center">
                      Delete
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {relatedMappers.map(relatedMapper => (
                    <TableRow key={`related-mappers-${relatedMapper.id!}`}>
                      <TableCell align="center">
                        <Priority
                          priority={relatedMapper.priority}
                          onEnterValue={v => {
                            props.onChangePriority(relatedMapper.id!, v);
                          }}
                          confirmText="Are you sure to change priority?"
                        />
                      </TableCell>
                      <TableCell align="center">{relatedMapper.relatedStoryId}</TableCell>
                      <TableCell>
                        <OuterLink
                          href={`${settings.getCrewURI()}/stories/${relatedMapper.relatedStoryId}`}
                          target="_blank"
                          className={classes.relatedStoryTitle}
                        >
                          {relatedMapper.relatedStory!.title}
                        </OuterLink>
                      </TableCell>
                      <TableCell align="center">{relatedMapper.relatedStory!.writer?.displayName}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          size="medium"
                          onClick={() => {
                            props.onDeleteMapper(relatedMapper.id!);
                          }}
                        >
                          <DeleteIcon color={'primary'} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          </Box>
        );
      })}
    </Box>
  );
};

export default RelatedStorySegment;
